import { gql } from "graphql-request";
export const TOTAL_ALL_NEWS = gql`
    query totalAllNews($domainId: Int, $typeId: Int) {
        allPosts(
            typeId: $typeId
            published: true
            isDeleted: false
            domainId: $domainId
            orderByDesc: createdAt
        ) {
            translations {
                key
                value
                language
            }
        }
    }
`;
